

















































import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import ProfileHeader from '@/components/user/profile/ProfileHeader.vue'
import CategoryEditor from '@/components/user/profile/CategoryEditor.vue'
import RewardList from '@/components/user/profile/RewardList.vue'
import DealBookmarkCard from '@/components/deal/DealBookmarkCard.vue'

@Component({
  name: 'Profile',
  components: {
    ProfileHeader,
    CategoryEditor,
    RewardList,
    DealBookmarkCard
  }
})
class Profile extends Vue {
  private get user() {
    return authModule.user
  }

  private get remainingDeals() {
    const remainder = 6 - (this.user!.points % 6)
    return (remainder === 1
      ? '1 weiteren Deal'
      : `${remainder} weitere Deals`
    ).toUpperCase()
  }

  private get points() {
    return this.user!.points > 6 ? this.user!.points % 6 : this.user!.points
  }

  private async created() {
    await authModule.fetchUser()
    await dealModule.fetchRewards()
  }
}
export default Profile
